import { FormikProps, useFormik } from 'formik';
import { INITIAL_PHONE_NUMBERS } from 'shared/constants/INITIAL_PHONE_NUMBERS';
import { RepresentationType } from 'shared/enums/RepresentationType';
import { ICreateTalentPayload, ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import * as yup from 'yup';

type FormProps = {
  onSubmit: (values: ICreateTalentPayload) => void;
};
export const useMinorForm = ({ onSubmit }: FormProps) => {
  const memberInitialValues: ICreateTalentPayload = {
    with_minor_work_permit: false,
    email: '',
    first_name: '',
    last_name: '',
    contact_no: '',
    country_code: '',
    adult_minor: 'minor',
    medium_id: '',
    gender: '',
    birth_date: undefined,
    stage_first_name: '',
    stage_middle_name: '',
    stage_last_name: '',
    identifies_as: '',
    sag_status: 'NON UNION',
    representation_type: RepresentationType.FREELANCE,
    sag_id: '',
    agency_ids: [],
    unions: [],
    work_permit_expired_at: undefined,
    middle_name: '',
    managed_by_minor: false,
    other_phone_numbers: INITIAL_PHONE_NUMBERS,
    completed_primary_details: false,
  };

  const memberValidationScheme = yup.object({
    email: yup.string().notRequired(),
    first_name: yup.string().required('First name is a required field'),
    last_name: yup.string().required('Last name is a required field'),
    contact_no: yup.string().notRequired().min(14, 'Contact number is not valid'),
    country_code: yup.string().notRequired(),
    adult_minor: yup.string().required(),
    gender: yup.string().required('Gender is a required field'),
    birth_date: yup.string(),
    stage_first_name: yup.string().required('Stage first name is required'),
    stage_middle_name: yup.string().notRequired(),
    stage_last_name: yup.string(),
    identifies_as: yup.string(),
    sag_status: yup.string().required('This is a required field'),
    representation_type: yup.string().required(),
    sag_id: yup.string().required(),
    agency_ids: yup.string(),
    with_minor_work_permit: yup.boolean().notRequired(),
    managed_by_minor: yup.boolean().notRequired(),
    work_permit_expired_at: yup.string().notRequired(),
    middle_name: yup.string().notRequired(),
    other_phone_numbers: yup.array().notRequired(),
    unions: yup.array().notRequired(),
  });

  const memberForm: FormikProps<ICreateTalentPayload> = useFormik({
    initialValues: memberInitialValues,
    validationSchema: memberValidationScheme,
    validateOnBlur: true,
    onSubmit: () => onSubmit(memberForm.values),
  });

  return {
    memberForm,
  };
};
